// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".frisbuy-outfit-on-model-item__description[data-v-0ffc1c25]{position:absolute;top:-24px;left:0;width:100%;text-align:center;overflow-wrap:break-word;overflow:hidden;color:#2e353b;font-family:Inter,sans-serif;font-size:24px;font-weight:400;padding-bottom:4px}.frisbuy-video-wrapper[data-v-0ffc1c25]{padding-bottom:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
